import { combineReducers } from 'redux';
import checkout from './checkout';

export default combineReducers({
  checkout,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts